export const resolveFirestopDetailName = (detailId, firestopDetails) => {
  if (!detailId) {
    return '';
  }

  const matchingFirestopDetail = (firestopDetails || []).find(
    (firestopDetail) => firestopDetail.id === detailId
  );

  return matchingFirestopDetail ? matchingFirestopDetail.name : detailId;
};
